import React, { useEffect, useState } from 'react';

import { Avatar } from '@material-ui/core';
import StrikeFullIcon from '@material-ui/icons/Cancel';
import StrikeEmptyIcon from '@material-ui/icons/PanoramaFishEye';

import { IResult } from '../../../../store/admin/roundResults/store';
import { TIFormatPrefix } from '../../../../store/admin/roundFormats/store';

import { userPic } from '../../../../assets/images';
import { useAssignResultsState } from '../../../admin/EventWizard/Common/AssignResults/Context/AssignResults.context';
import { getResultFieldName } from '../../../admin/EventWizard/Common/ResultsTable/Utils/getResultFieldName';

interface IStillInRaceUserInfo {
  result: IResult;
}

export const StillInRaceUserInfo = (props: IStillInRaceUserInfo) => {
  const {
    result,
    result: { userFirstName, userLastName, userImage }
  } = props;

  const { selectedRoundFormat, selectedFormat, selectedScoreType } = useAssignResultsState();

  const [playerStrikes, setPlayerStrikes] = useState<number>(0);

  useEffect(() => {
    if (selectedFormat && selectedScoreType) {
      if (selectedRoundFormat) {
        const selectedFormatPrefix = selectedFormat.prefix;

        const processedPrefix = `${selectedFormatPrefix}${
          selectedRoundFormat.considerFlights ? 'Flight' : 'Round'
        }` as TIFormatPrefix;

        setPlayerStrikes(result[
          getResultFieldName(processedPrefix, selectedScoreType, 'Strikes')
        ] as number);
      }
    }
  }, [selectedScoreType, selectedFormat, selectedRoundFormat]);

  return (
    <div className="playerInfo">
      <Avatar className="avatar override" src={userImage || userPic} sizes="40" />

      <div className="playerInfoMetadata">
        <p>{`${userFirstName} ${userLastName}`}</p>

        {selectedRoundFormat && selectedRoundFormat.strikes && playerStrikes > 0 && (
          <div className="strikes-container">
            {[...Array(selectedRoundFormat.strikes).keys()].map(strikeIndex =>
              strikeIndex < playerStrikes ? <StrikeFullIcon /> : <StrikeEmptyIcon />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
